import { FetcherJSONResponse } from 'services/fetcher';
import { User } from './types';

export function deserializeUser(data: FetcherJSONResponse) {
  return { ...data, createdAt: new Date(data.createdAt as string) } as User;
}
